import axios from 'axios'
import { LOGOUT_POST, AUTHORIZATION_PATH } from '../constants'
import { VALUES } from 'utils/constants'
import WebSocketService from '../services/WebSocketService'
// import { encryptJSON } from 'utils/utils'




const axiosClient = axios.create()
axiosClient.CancelToken = axios.CancelToken
axiosClient.isCancel = axios.isCancel

export const logoutUser = (dispatch, refresh_token, history) => {
   return new Promise((resolve, reject) => {
      const headers = { 'Content-Type': 'application/json' }
      const payload = { refreshToken: refresh_token }
      const endpoint = `${process.env.REACT_APP_LOGIN_API}${LOGOUT_POST}`

      new WebSocketService()
      const notificationsSocket = WebSocketService.getInstance()
      notificationsSocket.disconnect()
      axiosClient
         .post(endpoint, payload, { headers })
         .then(response => {
            dispatch({
               type: 'LOGOUT',
               session: response.data,
               authenticated: false
            })
            // dispatch({
            //    type: 'OPEN_SNACKBAR',
            //    openMessage: {
            //       open: true,
            //       message: `Su sesión ha caducado. Vuelva a iniciar sesión`,
            //       severity: 'error'
            //    }
            // })
         })
         .catch(error => {
            dispatch({ type: 'LOGOUT', session: '', authenticated: false })
            if (typeof error.response === 'undefined') {
               reject({
                  error: 'technical_error',
                  error_description:
                     'Occurió un problema comuniquese con el administrador.'
               })
            }
         })
   })
}
export const getRefreshToken = async payload => {
   const URL = `${process.env.REACT_APP_LOGIN_API}/users/refresh`
   const res = await axios.post(URL, payload)
   return res
}
// TODO: Eliminar, cuando NO se use en site-policies
export const getAuthorizationDataApi = async (accessToken, dispatch) => {
   const headers = { Authorization: `Bearer ${accessToken}` }
   const endpoint = `${process.env.REACT_APP_AUTHORIZATION_API}${AUTHORIZATION_PATH}`

   const response = await axiosClient
      .post(endpoint, {}, { headers })
      .catch(err => Promise.reject(err))

   const { data } = response

   const { resources, operations } = data
   let authorizedOptions = {}
   if (
      !!resources[VALUES.APP_RESOURCE_CODE] &&
      !!operations[VALUES.APP_RESOURCE_CODE]
   ) {
      const authorizedOperations = operations[VALUES.APP_RESOURCE_CODE]
      if (authorizedOperations.length) {
         const isAuthorized = optionCode =>
            authorizedOperations.some(op => op.code === optionCode)
         authorizedOptions = {
            addVideoTutoriales: isAuthorized(VALUES.VIDEO_TUTORIALS_CODE),
            addRegulatons: isAuthorized(VALUES.REGULATIONS_CODE)
         }
      }
   }

   dispatch({
      type: 'UPDATE_SESSION_DATA',
      payload: { settings: data, authorizedOptions }
   })
   return data
}

export const createThrid = async payload => {
   // const headers = { 'Content-Type': 'application/json' }
   const endpoint = `${process.env.REACT_APP_LOGIN_API}/users/register`
   return await axiosClient.post(endpoint, payload)
}
export const searchStatus = async (documentType, documentNumber) => {
   const endpoint = `${process.env.REACT_APP_CONTRIBUTOR_API}/contributor/information?DocumentNumber=${documentNumber}&DocumentType=${documentType}`
   return await axiosClient.get(endpoint)
}

export const createContributor = async value => {
   const endpoint = `${process.env.REACT_APP_LOGIN_API}/users/register`
   return await axiosClient.post(endpoint, value)
}
